import authInterceptor from "../../AuthInterceptor";

export const DefectCountThresholdAPI = {
  getThreshold: (flightModel) =>
    authInterceptor
      .get(`ranking-api/admin/defect-count-threshold/`, {
        params: { flight_model: flightModel },
      })
      .then((response) => response.data)
      .catch((error) => error.response),
  saveThreshold: (flightModel, bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/admin/defect-count-threshold/`, bodyData, {
        params: { flight_model: flightModel },
      })
      .then((response) => response.data)
      .catch((error) => error.response),
};
